import { Button, Form, Tooltip } from "antd"
import { formItemLayoutBalanced } from "../../_components/SettingFormItems"
import * as React from "react"
import { Router } from "../../../../../server/router"
import { getSelectedTerminalsLocationId } from "../../../../common/terminalPickers/selectors"
import { useSelector } from "react-redux"

type Props = {
    hideTopBorder?: boolean
    onChangeCallback: () => void
}
export const EditHoursOfOperationsRow = (props: Props) => {
    const selectedTerminalsLocationId = useSelector(getSelectedTerminalsLocationId)

    const openLocationDetail = () => {
        const locationId = selectedTerminalsLocationId

        if (locationId) {
            props.onChangeCallback()
            return Router.push(`/make-it-butter-settings/edit/${locationId}`)
        }

        return null
    }

    return (
        <div>
            <Form.Item
                className="receipt-setting-form-item"
                style={{
                    ...(props.hideTopBorder ? { borderTop: "none" } : null),
                    marginBottom: "0rem",
                }}
                {...formItemLayoutBalanced}
                label="Hours of Operations, Address, Phone, Email">
                {!selectedTerminalsLocationId ? (
                    <Tooltip placement="topRight" title="Select only one services from same location to allow changes">
                        <Button disabled={true}>Edit Location</Button>
                    </Tooltip>
                ) : (
                    <Button
                        onClick={() => {
                            openLocationDetail()
                        }}>
                        Edit Location
                    </Button>
                )}
            </Form.Item>
        </div>
    )
}
